import _ from 'lodash'
import { initialState } from './state'

export default {
  isLoading,
  doneLoading,
  toggleMaximized,
  openStudentModal,
  closeDetails,
  updateSelectedTab,
  setList,
  setStudentClassList,
  setAutoCompleteList,
  pushClassStudentList,
  updateForm,
  updateStudentForm,
  updateAddressForm,
  updateDriversLicenseForm,
  setStudentForm,
  setAddressForm,
  setSameAsBilling,
  setDriversLicenseForm,
  clearStudentForm,
  clearAddressForms,
  clearDriversLicenseForm,
  resetSearchFields,
  inApprovedClass,
  resetState
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}

function toggleMaximized (state, payload) {
  state.studentModal.maximized = !state.studentModal.maximized
}

function openStudentModal (state, { mode }) {
  state.studentModal.mode = mode
  state.studentModal.open = true
}

function closeDetails (state) {
  state.studentModal.open = false
  state.inApprovedClass = false
  state.studentModal.selectedTab = 'general'
}

function updateSelectedTab (state, payload) {
  state.studentModal.selectedTab = payload
}

function setList (state, { students }) {
  state.list = students
}

function setStudentClassList (state, { classes }) {
  state.studentClassList = classes
}

function setAutoCompleteList (state, { students }) {
  state.autoCompleteList = students
}

function updateForm (state, { form, field, value }) {
  Object.assign(state[form], {
    [field]: value
  })
}

function updateStudentForm (state, { field, value }) {
  console.log('field', field)
  console.log('value', value)
  Object.assign(state.studentForm, {
    [field]: value
  })
}

function updateAddressForm (state, { field, value }) {
  console.log('field', field)
  console.log('value', value)
  Object.assign(state.addressForm, {
    [field]: value
  })
}

function updateDriversLicenseForm (state, { field, value }) {
  console.log('field', field)
  console.log('value', value)
  Object.assign(state.driversLicenseForm, {
    [field]: value
  })
}

function setStudentForm (state, { student }) {
  _.each(student, (value, key) => {
    state.studentForm[key] = value
  })
}

function setAddressForm (state, { form, address }) {
  _.each(address, (value, key) => {
    state[form][key] = value
  })
}

function setSameAsBilling (state, { status }) {
  state.shippingAddressForm.sameAsBilling = status
}

function setDriversLicenseForm (state, { driversLicense }) {
  _.each(driversLicense, (value, key) => {
    state.driversLicenseForm[key] = value
  })
}

function clearStudentForm (state) {
  _.each(state.studentForm, (value, key) => {
    state.studentForm[key] = initialState.studentForm[key]
  })
}

function clearAddressForms (state) {
  _.each(state.billingAddressForm, (value, key) => {
    state.billingAddressForm[key] = initialState.billingAddressForm[key]
  })
  _.each(state.shippingAddressForm, (value, key) => {
    state.shippingAddressForm[key] = initialState.shippingAddressForm[key]
  })
}

function clearDriversLicenseForm (state) {
  _.each(state.driversLicenseForm, (value, key) => {
    state.driversLicenseForm[key] = initialState.driversLicenseForm[key]
  })
}

function pushClassStudentList (state, { student }) {
  state.classStudentList.push(student)
}

function resetSearchFields (state) {
  state.searchFields = { ...initialState.searchFields }
}

function inApprovedClass(state) {
  state.inApprovedClass = true
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}
